export default function PHP_throw() {
  return (
    <div>
      <h1>PHP_throw</h1>
    </div>
  );
}
